module.exports = __webpack_public_path__ + "img/COM-A-1-II.6148d465.png";